/**
 * Control logging. Can log to external service (eg Rollbar) and send extra config
 * TODO: Replace console with external logging service
 */

const { log, error } = console;

const logger = {
  log: (...args) => log(...args),
  error: (...args) => error(...args),
};

export default logger;
